import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector, } from 'react-redux'
import { Page, BookingsList, } from 'components';
import { Header, Statistics, Notifications, } from './components'

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.breakpoints.values.lg,
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3)
  },
  statistics: {
    marginTop: theme.spacing(3)
  },
  notifications: {
    marginTop: theme.spacing(6)
  },
  projects: {
    marginTop: theme.spacing(6)
  },
  todos: {
    marginTop: theme.spacing(6)
  }
}));

const Overview = () => {
  const classes = useStyles();
  const session = useSelector(state => state.session)
  let restrictedParkings = null

  if (session.user.roles === 'partner') {
    restrictedParkings = session.user.manager
  } else if (session.user.roles === 'gate_manager') {
    restrictedParkings = session.user.gateManager
  }

  return (
    <Page
      className={classes.root}
      title="Overview"
    >
      <Header />
      <Statistics className={classes.statistics} />
      <Notifications className={classes.notifications} />
      {session.user.roles !== 'agence' && <BookingsList
        userId={session.user.roles === ''}
        restrictedParkings={restrictedParkings}
        limit={10}
      />}
    </Page>
  );
};

export default Overview;
